import {OEToolboxCoreClass} from './oe-toolbox-core';
import {UIControllerType} from '../../react-oe/oe-types';

export class OEToolboxClass extends OEToolboxCoreClass {

    constructor() {
        super();
    }
    
    getTitleStringIdForUIControllerType(type)  {
        const uit = UIControllerType;
        if(!this.uiControllerTypeTitleStringIdMap)  {
            this.uiControllerTypeTitleStringIdMap = [
                {type: uit.cut, id: 'cut_view'},
                {type: uit.note, id: 'note_view'},
                {type: uit.component, id: 'tree_view'},
                {type: uit.substructure, id: 'substructure_view'},
                {type: uit.search_tool, id: 'search_view'},
                {type: uit.selection, id: 'selection_view'},
                {type: uit.label, id: 'label_view'},
                {type: uit.presentation, id: 'presentation_view'},
                {type: uit.animation, id: 'animations_view'},
                {type: uit.media_center, id: 'media_center_view'},
                {type: uit.settings, id: 'settings_view'},
                {type: uit.search_controller, id: 'search_view'}
            ];
        }
        let res = this.uiControllerTypeTitleStringIdMap.find(e => e.type === type);
        return res ? res.id : undefined;
    }

    loadFiles(event, appComponent, loadFn, multiFile = false) {
        event.stopPropagation();
        event.preventDefault();

        if(!event.target.files.length)  return;

        if(appComponent)    appComponent.showWaitingController();

        let files = multiFile ? event.target.files : [event.target.files[0]];

        let allFileProgress = {i: 0, num: files.length};

        let onLoadFunc = function(event)  {
            if(event.target.readyState != FileReader.DONE)  return;

            let arrayBuffer = event.target.result;
            loadFn(event, arrayBuffer);

            allFileProgress.i = allFileProgress.i + 1;
            if(allFileProgress.i == allFileProgress.num)    {
                if(appComponent)    appComponent.hideWaitingController();
            }
        };

        for(let i = 0; i < files.length; ++i)  {
            let reader = new FileReader();
            reader.onload = onLoadFunc;
            reader.readAsArrayBuffer(files[i]);
        }
    }

    printStorageStats() {
        if(!navigator.storage || !navigator.storage.estimate)   return;
        navigator.storage.estimate().then(({usage, quota, usageDetails}) => {
            console.log(`Storage - used: ${(usage / 1024 / 1024).toFixed(2)} MB, quota: ${(quota / 1024 / 1024).toFixed(2)} MB, usage percentage: ${((usage / quota) * 100).toFixed(2)}%`);
        });
    }
};

export default new OEToolboxClass();